var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHalloweenQuote = function SvgHalloweenQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.731 18.869c0 1.126.388 2.218 1.097 3.093l6.235 7.694c.634.782 1.9.334 1.9-.673v-7.325c0-.59.478-1.069 1.068-1.069h7.831c.59 0 1.069-.479 1.069-1.069V1.069c0-.59-.479-1.069-1.069-1.069H25.296a2.565 2.565 0 00-2.565 2.566v16.303z",
    fill: "url(#halloweenQuote_svg__paint0_linear_10550_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.869c0 1.126.388 2.218 1.097 3.093l6.235 7.694c.634.782 1.9.334 1.9-.673v-7.325c0-.59.478-1.069 1.068-1.069h7.831c.59 0 1.069-.479 1.069-1.069V1.069C19.2.479 18.721 0 18.131 0H2.566A2.566 2.566 0 000 2.566v16.303z",
    fill: "url(#halloweenQuote_svg__paint1_linear_10550_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "halloweenQuote_svg__paint0_linear_10550_167",
    x1: 32.331,
    y1: -15,
    x2: 32.331,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "halloweenQuote_svg__paint1_linear_10550_167",
    x1: 9.6,
    y1: -15,
    x2: 9.6,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4900"
  })))));
};
export default SvgHalloweenQuote;